import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { useGetWorkflowsExecutionChannelSummary } from "@features/ux/components/workflow/hooks";
import { MailCheck, MailX, Send } from "lucide-react";
import React from "react";
import { useParams } from "react-router-dom";

const TextMessageDashboard = () => {
  const { id } = useParams();
  const { data: textMessageSummary } = useGetWorkflowsExecutionChannelSummary(id,"sms");
  const statsData = [
    {
      title: "Sent",
      count: textMessageSummary?.sent,
      icon: <Send className="h-7 w-7 text-gray-600" />,
    },
    {
      title: "Successful",
      count: textMessageSummary?.successful,
      icon: <MailCheck className="h-7 w-7 text-blue-600" />,
    },
    {
      title: "Failed",
      count: textMessageSummary?.failed,
      icon: <MailX className="h-7 w-7 text-amber-600" />,
    },
  ];
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {statsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          icon={stat.icon}
        />
      ))}
    </div>
  );
};

export default TextMessageDashboard;
